import { Element } from '../../../common/html/element'
import classes from '../../index.module.scss'
import { ORDER_TYPE } from './constants'
import { Price } from './popupBuyPackage/common/price'

const APPEND_CLASSNAME_PRICE = `${classes.w44}`

export const PriceConfirmationBox = ({
  exchangeRateAPI,
  oldPrice,
  discountedAmount,
  discountValue,
  vatPrice,
  grandTotalPrice,
  orderType,
}) => {
  const renderContent = () => {
    switch (orderType) {
      case ORDER_TYPE.BOTH_SNP:
        return (
          <Price
            title="userManagement.buyPackage.TOTAL"
            price={discountedAmount}
            exchangeRateAPI={exchangeRateAPI}
            classNamePrice={APPEND_CLASSNAME_PRICE}
          />
        )
      case ORDER_TYPE.PACKAGE:
        return (
          <>
            <Price
              title="userManagement.buyPackage.TOTAL_PRICE"
              price={oldPrice || discountedAmount}
              exchangeRateAPI={exchangeRateAPI}
              classNamePrice={APPEND_CLASSNAME_PRICE}
            />
            <Price
              title="userManagement.buyPackage.TRADE_DISCOUNT"
              price={discountValue}
              exchangeRateAPI={exchangeRateAPI}
              classNamePrice={APPEND_CLASSNAME_PRICE}
            />
          </>
        )
      case ORDER_TYPE.REPORT:
        return (
          <>
            <Price
              title="userManagement.buyPackage.TOTAL_PRICE"
              oldPrice={oldPrice}
              price={discountedAmount}
              exchangeRateAPI={exchangeRateAPI}
              classNamePrice={APPEND_CLASSNAME_PRICE}
            />
            <Price
              title="userManagement.buyPackage.TRADE_DISCOUNT"
              price={discountValue}
              exchangeRateAPI={exchangeRateAPI}
              classNamePrice={APPEND_CLASSNAME_PRICE}
            />
          </>
        )
      default:
        return (
          <Price
            title="userManagement.buyPackage.PRICE"
            oldPrice={oldPrice}
            price={discountedAmount}
            exchangeRateAPI={exchangeRateAPI}
            classNamePrice={APPEND_CLASSNAME_PRICE}
          />
        )
    }
  }
  return (
    <Element
      style={{
        backgroundColor: '#FFFFFF',
        padding: '12px 12px 2px 12px',
        marginTop: 12,
      }}
      className={classes.content}
    >
      {renderContent()}
      <Price
        title="userManagement.buyPackage.VAT"
        price={vatPrice}
        exchangeRateAPI={exchangeRateAPI}
        classNamePrice={APPEND_CLASSNAME_PRICE}
      />
      <Price
        title="userManagement.buyPackage.GRAND_TOTAL"
        price={grandTotalPrice}
        exchangeRateAPI={exchangeRateAPI}
        classNamePrice={APPEND_CLASSNAME_PRICE}
      />
    </Element>
  )
}
